module.exports = __webpack_public_path__ + "static/hotblack-coffee-space-e0dedcf63901c769445b600d19c46be2.jpg";